import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { StepCard, Field, ToggleRow, GROUPING_LABEL_OPTIONS } from "./_helpers";

/** Step 3 — optional grouping (Domain / Area / Custom). */
export default function Step3Grouping({
  categorySettings, onChange, groups,
  onAddGroup, onUpdateGroup, onDeleteGroup, categoryPlural,
}) {
  return (
    <StepCard step="Step 3" title="Grouping Option"
      subtitle={`Group ${categoryPlural.toLowerCase()} under a higher-level label (e.g. ${categoryPlural} → Group).`}
      testId="step-3"
    >
      <ToggleRow
        label="Enable Category Grouping"
        description=""
        checked={categorySettings.grouping_enabled}
        onChange={(v) => onChange({ grouping_enabled: v })}
        testId="gs-grouping-enabled"
        flat
      />
      {categorySettings.grouping_enabled && (
        <div className="mt-3">
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="GROUPING LABEL">
              <select value={categorySettings.grouping_label}
                onChange={(e) => onChange({ grouping_label: e.target.value })}
                className="gs-select" data-testid="gs-grouping-label">
                {GROUPING_LABEL_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </Field>
            {categorySettings.grouping_label === "custom" && (
              <Field label="CUSTOM GROUPING LABEL">
                <Input value={categorySettings.custom_grouping_label || ""}
                  onChange={(e) => onChange({ custom_grouping_label: e.target.value })}
                  placeholder="e.g. Strand" className="rounded-xl h-11" data-testid="gs-custom-grouping-label" />
              </Field>
            )}
          </div>

          <div className="border-t border-brand-purple/10 mt-4 pt-3">
            <div className="flex items-center justify-between mb-2">
              <p className="font-heading text-sm font-semibold text-foreground">Groups</p>
              <Button size="sm" variant="outline" onClick={onAddGroup} className="rounded-xl" data-testid="gs-add-group">
                <Plus className="w-3.5 h-3.5 mr-1" /> Add Group
              </Button>
            </div>
            {groups.length === 0
              ? <p className="text-xs text-brand-inkMuted py-3 text-center bg-brand-purpleLight/30 rounded-xl">No groups yet.</p>
              : groups.map((g) => (
                <div key={g.id} className="grid grid-cols-12 gap-2 items-center mb-2" data-testid={`gs-group-${g.id}`}>
                  <Input value={g.group_name} onChange={(e) => onUpdateGroup(g.id, { group_name: e.target.value })}
                    placeholder="Group name" className="col-span-4 rounded-xl h-10" />
                  <Input value={g.description || ""} onChange={(e) => onUpdateGroup(g.id, { description: e.target.value })}
                    placeholder="Description (optional)" className="col-span-7 rounded-xl h-10" />
                  <Button size="icon" variant="ghost" onClick={() => onDeleteGroup(g.id)} className="col-span-1 text-[#C62828]"
                    data-testid={`gs-del-group-${g.id}`}><Trash2 className="w-4 h-4" /></Button>
                </div>
              ))}
          </div>
        </div>
      )}
    </StepCard>
  );
}
